import { Link } from "react-router-dom";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block relative"
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#121212]">
        {product.images?.[0] && (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          />
        )}
        {!product.in_stock && (
          <span className="absolute top-3 left-3 bg-black/80 text-white text-[10px] tracking-[0.2em] uppercase px-2 py-1">
            Sold Out
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#c8102e] font-semibold">
          {product.category}
        </p>
        <h3 className="font-display text-lg tracking-wider mt-1 uppercase">
          {product.name}
        </h3>
        <p className="text-white font-semibold mt-2">${product.price.toFixed(2)}</p>
      </div>
    </Link>
  );
}
